import { ChecklistDocuments } from "@interfaces/catalogs";

export const DEFAULT_CHECKLIST_PM: ChecklistDocuments = [
  {
    title: "De la empresa",
    tooltip:
      "Una empresa es una entidad formada por un grupo de personas que se unen con el objetivo de producir bienes o servicios para satisfacer necesidades del mercado.",
    documents: [
      "Acta constitutiva y sus adicionales",
      "Comprobante de domicilio operativo no mayor a 3 meses",
      "Últimos 3 estados de cuenta",
      "Fiel de la empresa",
    ],
  },
  {
    title: "Del representante legal",
    tooltip: "",
    documents: [
      "Constancia de situación fiscal",
      "Identificación y validación de identidad",
      "Comprobante de domicilio",
      "Fiel para firma del contrato",
    ],
  },
  {
    title: "Del aval o accionista mayoritario",
    tooltip:
      "Es el accionista mayoritario de la empresa, que a su vez, será la persona encargada de asegurar que se saldará la deuda.",
    documents: [
      "Comprobante de domicilio no mayor a 3 meses",
      "Últimos 3 estados de cuenta",
      "Constancia de situación fiscal",
      "Identificación oficial vigente (INE, Pasaporte, FM2)",
    ],
  },
  {
    title: "Del propietario real",
    tooltip:
      "Persona Física que directa o indirectamente sea titular del 25% de las acciones de la empresa, o que siendo titular de un porcentaje menor, ejerza el control sobre la misma, regularmente el representante legal.",
    documents: ["Constancia de situación fiscal", "Identificación oficial vigente (INE, Pasaporte, FM2)"],
  },
];

export const DEFAULT_CHECKLIST_PFAE: ChecklistDocuments = [
  {
    title: "De la persona física con act. empresarial",
    tooltip: "",
    documents: [
      "Identificación y validación de identidad",
      "Comprobante de domicilio",
      "Últimos 3 estados de cuenta",
      "Fiel de la persona para firma del contrato",
    ],
  },
];

export const DEFAULT_CHECKLIST_PF: ChecklistDocuments = [
  {
    title: "De la persona física",
    tooltip: "",
    documents: [
      "Identificación y validación de identidad",
      "Comprobante de domicilio",
      "Últimos 3 estados de cuenta",
      "Fiel de la persona para firma del contrato",
    ],
  },
];
